import script from "./propagateList.vue?vue&type=script&setup=true&lang=js"
export * from "./propagateList.vue?vue&type=script&setup=true&lang=js"

import "./propagateList.vue?vue&type=style&index=0&id=fe161a6e&lang=scss&scoped=true"

import exportComponent from "/Users/wlxqxxf/铭方营养/nutrition-web-wechat/node_modules/_vue-loader@16.8.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe161a6e"]])

export default __exports__